import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"

import styles from "./PrivateFooterBottom.module.scss"

type Props = {}

const PrivateFooterBottom = (props: Props): any => {
	const year = new Date().getFullYear()
	return (
		<Typography
			className={styles.container}
			content={`One Communications Ltd. I Copyright ${year} I Keilalahdentie 2-4 FI-02150 Espoo Finland`}
			variant={Variant.Description}
			contrast
		/>
	)
}

export default PrivateFooterBottom
